"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Send;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Send(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M19.863 3.587a.375.375 0 0 0-.384-.058L2.231 10.653a.375.375 0 0 0 .007.695l4.749 1.844a.375.375 0 0 0 .35-.042l6.3-4.48a.375.375 0 0 1 .478.576l-5.25 5.059a.375.375 0 0 0-.114.27v5.049a.375.375 0 0 0 .698.189l2.375-4.068a.188.188 0 0 1 .253-.07l4.369 2.4a.375.375 0 0 0 .547-.25l3-13.873a.381.381 0 0 0-.13-.365z"
  }));
}